import {
  EliteApes,
  BinanceLogo,
  ButterLogo,
  FrontierAcademyLogo,
  SandboxEcoSystemLogo,
  TinyEcoSystemLogo,
  AnimocaEcoSystemLogo,
  GemsEcoSystemLogo,
} from './assets/logos/partners-colored'
import ocId from './assets/icons/header/oc-id.svg'
import oc100 from './assets/icons/header/oc-100.svg'
import funding from './assets/icons/header/funding.svg'
import global from './assets/icons/header/global.svg'
import ocIdMobile from './assets/icons/header/mobile/oc-id.svg'
import oc100Mobile from './assets/icons/header/mobile/oc-100.svg'
import fundingMobile from './assets/icons/header/mobile/funding.svg'
import globalMobile from './assets/icons/header/mobile/global.svg'
import Power1 from './assets/images/home-page/power/power-1.svg'
import Power2 from './assets/images/home-page/power/power-2.svg'
import Power3 from './assets/images/home-page/power/power-3.svg'
import Power4 from './assets/images/home-page/power/power-4.svg'
import Power5 from './assets/images/home-page/power/power-5.svg'
import Power6 from './assets/images/home-page/power/power-6.svg'
import Power7 from './assets/images/home-page/power/power-7.svg'
import Power8 from './assets/images/home-page/power/power-8.svg'
import Power9 from './assets/images/home-page/power/Power9.png'
import Power10 from './assets/images/home-page/power/Power10.png'
import Power11 from './assets/images/home-page/power/Power11.png'
import Power12 from './assets/images/home-page/power/Power12.png'
import Power13 from './assets/images/home-page/power/Power13.png'
import Power14 from './assets/images/home-page/power/Power14.png'
import Coinmarketcap from './assets/logos/partners-colored/coin-market-cap.svg'
import Mocaverse from './assets/logos/partners-colored/mocaverse.svg'
import DecryptUni from './assets/logos/partners-colored/decrypt-u.svg'
import EdTechGround from './assets/logos/partners-colored/etg.svg'
import FlyingChalks from './assets/logos/partners-colored/flying-chalks.svg'
import InvestEd from './assets/logos/partners-colored/invest-ed.svg'
import BitDegree from './assets/logos/partners-colored/bit-degree.svg'
import Somos from './assets/logos/partners-colored/somos.svg'
import Bondex from './assets/logos/partners-colored/bondex.svg'
import HookedHP from './assets/logos/partners-colored/hooked-hp.svg'
import HighstreetMK from './assets/logos/partners-colored/hightreet-mk.svg'
import CoderSchool from './assets/logos/partners-colored/coderschool.svg'
import Algoritma from './assets/logos/partners-colored/algoritma.svg'
import Edu3Labs from './assets/logos/partners-colored/edu3Labs.svg'
import BinancePay from './assets/logos/partners-colored/binance-pay.svg'
import BlockchainCenter from './assets/logos/partners-colored/blockchain-center.svg'
import EduCup from './assets/logos/partners-colored/educup.svg'
import Boring from './assets/logos/partners-colored/boring-security.svg'
import HelpBnk from './assets/logos/partners-colored/help-bnk.webp'
import Mentogram from './assets/logos/partners-colored/menogram.svg'
import Skizaa from './assets/logos/partners-colored/skizaa.svg'
import TenTen from './assets/logos/partners-colored/10ten.svg'
import Superflow from './assets/logos/partners-colored/superflow.svg'
import LearningFrequency from './assets/logos/partners-colored/learning-frequecy.webp'
import SkillMapper from './assets/logos/partners-colored/skill-mapper.svg'
import BSDEducation from './assets/logos/partners-colored/bsd-education.svg'
import OWNAcademy from './assets/logos/partners-colored/own-academy.svg'
import Edukita from './assets/logos/partners-colored/edukita.svg'
import FutureLab from './assets/logos/partners-colored/future.svg'
import Bag from './assets/logos/partners-colored/bag.svg'
import Collective from './assets/logos/partners-colored/collective.svg'
import RiseIn from './assets/logos/partners-colored/rise-in.svg'
import EYouth from './assets/logos/partners-colored/eyouth.svg'
import Hackquest from './assets/logos/partners-colored/hackquest.svg'
import TranscendNetwork from './assets/logos/partners-colored/transcend.svg'
import RakaminAcademy from './assets/logos/partners-colored/rakamin.svg'
import Atiom from './assets/logos/partners-colored/atiom.svg'
import Ostad from './assets/logos/partners-colored/ostad.svg'
import Workademy from './assets/logos/partners-colored/workademy.svg'
import BNous from './assets/logos/partners-colored/bnous.svg'
import InteractiveCares from './assets/logos/partners-colored/interactive-care.webp'
import NewCampusEcoSystem from './assets/logos/partners-colored/new-campus-eco.svg'
import DexTool from './assets/logos/partners-colored/dextools-academy.png'

import dollaredu from './assets/images/home-page/carousel/dollaredu.png'
import educhain from './assets/images/home-page/carousel/educhain.png'
import incubator from './assets/images/home-page/carousel/incubator.png'
import ocid from './assets/images/home-page/carousel/ocid.png'
import ocx from './assets/images/home-page/carousel/ocx.png'
import pnfts from './assets/images/home-page/carousel/pnfts.png'

import buyEdu from './assets/images/home-page/Journey/buyEdu.svg'
import whiteList from './assets/images/home-page/Journey/whitelist.svg'

export const MED_DESKTOP_WIDTH = 1024
export const SITE_DOMAIN = 'www.opencampus.xyz'
export const WEB3_TT_COM = 'web3.tinytap.com'
export const CONTACT_EMAIL = 'info@opencampus.xyz'
export const PUBLISHER_NFT = 'Publisher NFT'

export const SOCIAL_LINKS = {
  twitter: 'https://twitter.com/opencampus_xyz',
  youtube: 'https://www.youtube.com/@OpenCampusxyz',
  telegram: 'http://opencampustg/',
  discord: 'https://discord.com/invite/open-campus-1088034981814738995',
  linkedin: 'https://www.linkedin.com/company/opencampus-xyz/about',
}

export const PARTNERS_LINKS = {
  tinytap: 'https://www.start.tinytap.com/animoca-brands/?source=3',
  tinytapNft: 'https://www.start.tinytap.com/publisher-nft',
  animoca: 'https://www.animocabrands.com',
  mocaverse: 'https://mocaverse.xyz/',
  sandbox: 'https://www.sandbox.game/en/',
  hooked: 'https://hooked.io/',
  gems: 'https://www.gemseducation.com/',
  highstreet: 'https://www.highstreet.market/',
  whitepaper: 'https://userdocs.opencampus.xyz',
}

export const STRATEGIC_AND_FINANCE = [
  { logo: BinanceLogo, url: 'https://www.binance.com/en' },
  { logo: Coinmarketcap, url: 'https://coinmarketcap.com/' },
  { logo: AnimocaEcoSystemLogo, url: 'https://www.animocabrands.com/' },
  { logo: Mocaverse, url: 'https://www.mocaverse.xyz/' },
  { logo: DecryptUni, url: 'https://decrypt.co/university' },
  { logo: GemsEcoSystemLogo, url: 'https://www.gemseducation.com/' },
  { logo: EdTechGround, url: 'https://edtechasia.com/' },
  { logo: FlyingChalks, url: 'https://www.flyingchalks.com/en' },
  { logo: InvestEd, url: 'https://www.invested.ph/' },
  { logo: BitDegree, url: 'https://www.bitdegree.org/' },
  { logo: Somos, url: 'https://www.somoseducacao.com.br/' },
  { logo: Bondex, url: 'https://bondex.app/' },
  { logo: HookedHP, url: 'https://hooked.io/' },
  { logo: HighstreetMK, url: 'https://www.highstreet.market/' },
  { logo: NewCampusEcoSystem, url: 'https://www.newcampus.com/' },
  { logo: TinyEcoSystemLogo, url: 'https://www.tinytap.com/content/' },
  { logo: Edu3Labs, url: 'https://edu3labs.com/' },
  { logo: EliteApes, url: 'https://www.eliteapes.io/about-elite-apes/' },
  { logo: BinancePay, url: 'https://pay.binance.com/en' },
  { logo: BlockchainCenter, url: 'https://blockchaincentre.io/' },
  { logo: DexTool, url: 'https://info.dextools.io/academy/' },
]

export const CAREER_GROWTH = [
  { logo: Collective, url: 'https://collectiveacademy.com/' },
  { logo: RiseIn, url: 'https://www.risein.com/' },
  { logo: FrontierAcademyLogo, url: 'https://frontieracademy.ai/' },
  { logo: EYouth, url: 'https://eyouthlearning.com/' },
  { logo: Hackquest, url: 'https://HackQuest.io' },
  { logo: TranscendNetwork, url: 'https://www.transcend-network.com' },
  { logo: RakaminAcademy, url: 'https://www.rakamin.com/' },
  { logo: Atiom, url: 'www.atiom.app' },
  { logo: Ostad, url: 'https://ostad.app/' },
  { logo: Workademy, url: 'https://www.theworkademy.com/' },
  { logo: BNous, url: 'https://www.bnous.com/' },
  { logo: InteractiveCares, url: 'https://interactivecares-courses.com/' },
]

export const CORE_LEARNING = [
  { logo: BSDEducation, url: 'https://bsd.education/' },
  { logo: OWNAcademy, url: 'https://ownacademy.co/' },
  { logo: Edukita, url: 'https://www.edukita.com/' },
  { logo: FutureLab, url: 'https://www.futurelab.my/' },
  { logo: Bag, url: 'https://www.bag.work/' },
]

export const INFRASTRUCTURE = [
  { logo: Skizaa, url: 'https://www.skizaa.com/' },
  { logo: TenTen, url: 'https://www.10ten.io/' },
  { logo: Superflow, url: 'https://www.superflow.team/' },
  { logo: ButterLogo, url: 'https://www.butter.us/' },
  { logo: LearningFrequency, url: 'https://www.learningfrequency.com' },
  { logo: SkillMapper, url: 'https://skillmapper.ai/' },
]

export const SOCIAL_CONTENT = [
  { logo: EduCup, url: 'https://educup.io/' },
  { logo: Boring, url: 'https://boringsecurity.com' },
  { logo: HelpBnk, url: 'https://helpbnk.com' },
  { logo: Mentogram, url: 'https://mentogram.com/' },
  { logo: SandboxEcoSystemLogo, url: 'https://www.sandbox.game/en/' },
]

export const HOME_ECOSYSTEM = [
  { id: 1, category: 'Strategic & Finance', brands: STRATEGIC_AND_FINANCE },
  { id: 2, category: 'Career Growth', brands: CAREER_GROWTH },
  { id: 3, category: 'Core Learning', brands: CORE_LEARNING },
  { id: 4, category: 'Infrastructure', brands: INFRASTRUCTURE },
  { id: 5, category: 'Social Content', brands: SOCIAL_CONTENT },
]

export const HOME_POWERS = [
  {
    image: Power1,
    logo: Power5,
    url: 'https://id.opencampus.xyz',
    tab: '_blank',
    description:
      'Decentralized learning profiles recording OC partner credentials minted with $EDU',
  },
  {
    image: Power2,
    logo: Power6,
    url: 'https://opencampus.xyz/staking',
    tab: '_blank',
    description:
      'Tokenized course contents minted with $EDU and distribute equitable return to Co-Publishers and creators in $EDU',
  },
  {
    image: Power3,
    logo: Power7,
    url: '#mainDiscoverSystem',
    tab: '_self',
    description:
      'A consortium of partners in education and Web3 adopting Open Campus protocols',
  },
  {
    image: Power4,
    logo: Power8,
    url: 'https://ocx.opencampus.xyz/',
    tab: '_blank',
    description:
      '6-week accelerator program, providing funding, network, and growth resources for education-focused startups.',
  },
  {
    image: Power9,
    logo: Power10,
    url: '#',
    tab: '_blank',
    disable: true,
    description:
      'Online social learning program incentivized in $EDU, powered by AI.',
  },
  {
    image: Power11,
    logo: Power12,
    url: 'https://forum.opencampus.xyz/t/ocp-3-global-educators-fund-batch-1/25',
    tab: '_blank',
    description:
      'Incentivizing qualified educators to create courses that can be tokenized and sold as Publisher NFTs.',
  },
  {
    image: Power13,
    logo: Power14,
    url: 'https://dao.opencampus.xyz',
    tab: '_blank',
    description:
      'The decision-making collective for education on chain, powered by $EDU token holders.',
  },
]

export const HOME_CAROUSEL_ITEMS = [
  {
    title: 'EDU Chain',
    description: 'EDU Chain, the first blockchain for education built by Open Campus',
    image: educhain,
    url: 'https://educhain.xyz'
  },
  {
    title: '$EDU',
    description: '$EDU is the native gas token for EDU Chain and the governance token for the Open Campus DAO',
    image: dollaredu,
    url: 'https://coinmarketcap.com/currencies/open-campus/'
  },
  {
    title: 'Open Campus ID',
    description: 'On-chain learning profiles store educational credentials that are minted using the $EDU token',
    image: ocid,
    url: 'https://id.opencampus.xyz/'
  },
  {
    title: 'OC-X',
    description: '6-week accelerator program, providing funding, network, and growth resources for education-focused startups',
    image: ocx,
    url: 'https://ocx.opencampus.xyz/'
  },
  {
    title: 'OC-Incubator',
    description: '12-week, equity-free, remote incubator program helps developers secure traction and investment for their dapps',
    image: incubator,
    url: 'https://oci.opencampus.xyz/'
  },
  {
    title: 'Publisher NFTs',
    description: 'Tokenized educational course content, minted with $EDU',
    image: pnfts,
    url: 'https://mint.opencampus.xyz/nft-catalog'
  },
]

export const MENU_PRODUCTS = [
  {
    title: 'OC-ID',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://id.opencampus.xyz/',
  },
  {
    title: 'OC Achievements',
    icon: undefined,
    iconMobile: undefined,
    url: '/oc-achievements',
  },
  {
    title: 'Open Campus Agents',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://agents.opencampus.xyz/',
  },
  {
    title: 'Publisher NFT',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://mint.opencampus.xyz/nft-catalog',
  },
  {
    title: 'Publisher NFT Staking',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://opencampus.xyz/staking',
  },
]

// Homepage product links shown in the More menu and footer Products column.
export const HOME_PRODUCTS = [
  { title: 'OCID', url: 'https://id.opencampus.xyz/' },
  { title: 'OC Achievements', url: '/oc-achievements' },
  { title: 'Publisher NFT', url: 'https://mint.opencampus.xyz/nft-catalog' },
  { title: 'Publisher NFT Staking', url: 'https://opencampus.xyz/staking' },
]

export const MENU_EDU_CHAIN = [
  {
    title: 'Home',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://www.educhain.xyz/',
  },
  {
    title: 'Bridge',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://yuzu.educhain.xyz/bridge',
  },
  {
    title: 'Stake $EDU',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://yuzu.educhain.xyz/stake',
  },
  {
    title: 'News',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://medium.com/edu-chain',
  },
  {
    title: 'Ecosystem',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://app.sailfish.finance/ecosystem',
  },
]

export const MENU_DEVELOPER = [
  {
    title: 'Block Explorer',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://explorer.educhain.xyz/',
  },
  {
    title: 'Github',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://github.com/opencampus-xyz',
  },
  {
    title: 'Dev Docs',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://devdocs.educhain.xyz/',
  },
]

export const MENU_FUNDING = [
  {
    title: 'Hackathons',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://www.risein.com/bootcamps/edu-chain-hackathon-semester-2',
  },
  {
    title: 'OC Incubator',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://oci.opencampus.xyz/',
  },
  {
    title: 'OC Accelerator',
    icon: undefined,
    iconMobile: undefined,
    url: 'https://ocx.opencampus.xyz/',
  },
]

/**
 * REACT_APP_PNFT_IPFS=https://ipfs.io/ipfs/QmbgYqfVh7HDGH39pU4gtjSp9RP15jKieMEnjW7RfZAWsN
REACT_APP_PNFT_IPFS_PROD=https://ipfs.io/ipfs/QmNYfH8gMDp3Nf3Ad4F4SonnubESPQqouN7WXT5rpfC49F
 */
